var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"dense":""},on:{"click":_vm.onClickBatchDelete}},[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm._f("t")(_vm.deleteLabel))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }